/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { DeliveryZipCode } from './DeliveryZipCode';

const DeliveryZipCodeDisplay = ({
  deliveryZip, setDeliveryZip, setDisabled, showNewATQUI
}) => {
  const [isEditing, setIsEditing] = useState(showNewATQUI ? !deliveryZip : true);

  const startEditing = () => {
    setIsEditing(true);
  };

  useEffect(() => {
    return () => {
      setIsEditing(false);
    };
  }, []);

  if (isEditing) {
    return (
      <div className="sui-mb-6">
        <DeliveryZipCode
          deliveryZip={deliveryZip}
          setDeliveryZip={setDeliveryZip}
          setDisabled={setDisabled}
        />
      </div>
    );
  }

  return (
    <div>
      <Typography weight="bold">Delivery ZIP Code</Typography>
      <div className="sui-mt-2 sui-mb-6 sui-flex">
        <Typography>{deliveryZip}</Typography>
        <div className="sui-ml-2">
          <Link
            component="button"
            onClick={startEditing}
            data-testid="change-delivery-zip"
          >
            <Typography>Change</Typography>
          </Link>
        </div>
      </div>
    </div>
  );
};

DeliveryZipCodeDisplay.propTypes = {
  deliveryZip: PropTypes.string.isRequired,
  setDeliveryZip: PropTypes.func.isRequired,
  setDisabled: PropTypes.func.isRequired,
  showNewATQUI: PropTypes.bool
};

DeliveryZipCodeDisplay.defaultProps = {
  showNewATQUI: false
};

DeliveryZipCodeDisplay.displayName = 'DeliveryZipCodeDisplay';

export { DeliveryZipCodeDisplay };
